export default __webpack_public_path__ + "static/media/navbar-shorten-link-dark.f1671ca0.svg";